import { isAfter, isBefore } from 'date-fns';
import { newDate } from '../../../utils/date';
import { WCHANCE_SURVEY_STATUS } from '../constants';
import type { WChanceLabelStatus } from '../types';

export type WChanceLabelStatusParams = {
  startAt: string;
  endAt: string;
  hasStock: boolean;
};

export type WChanceLabelStatusConfig = {
  is_session: WChanceLabelStatus;
  soon_start: WChanceLabelStatus;
  finish: WChanceLabelStatus;
  sold_out: WChanceLabelStatus;
};

// ラベルのステータスを返す
// 期間終了後であれば完売でも「終了」を返す
export const wchanceLabelStatus = (params: WChanceLabelStatusParams, config: WChanceLabelStatusConfig) => {
  const { startAt, endAt, hasStock } = params;

  // 開始前
  if (isBefore(newDate(), newDate(startAt))) return config.soon_start;
  // 終了
  if (isAfter(newDate(), newDate(endAt))) return config.finish;
  // 完売
  if (!hasStock) return config.sold_out;
  // 抽選期間中
  return config.is_session;
};

// Wチャンスのアンケートステータスを返す
export const getSurveyStatus = (surveyUrl: string, surveyId: string | null, isSurveyCompleted: boolean) => {
  if (!surveyUrl && !surveyId) return WCHANCE_SURVEY_STATUS.no_need_comp;
  if (!isSurveyCompleted) return WCHANCE_SURVEY_STATUS.not_comp;
  return WCHANCE_SURVEY_STATUS.comp;
};
